import React, { ReactElement } from "react";

import styled from "styled-components";

import DotImage from "./DotImage";

const ItemContainer = styled.div`
  display: flex;
  margin-top: 1em;
`;

const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 1em;
`;

type Props = {
  items: ReactElement[];
  color?: string;
};

export default function DotList({ items, color = "#72E85F" }: Props) {
  return (
    <>
      {items.map((item) => (
        <span key={item.key} style={{ marginBottom: 10 }}>
          <ItemContainer>
            <ImageContainer>
              <DotImage color={color} />
            </ImageContainer>
            {item}
          </ItemContainer>
        </span>
      ))}
    </>
  );
}
